import React from "react";
import { Box, Typography, Button, Grid, Chip } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import BannerImage from '../assets/images/Banner1.jpg'
import "swiper/css";
import useScrollToTraining from "../utils/useScrollToTraining";

const techTags = [
  "Azure Data Engineering",
  "Azure Databricks",
  "AWS",
  "Snowflake",
  "BigData",
  "JAVA",
  "GCP",
  "Full stack Data Engineering",
];

const videos = [
  {
    title: "Azure Data Engineering",
    url: "https://www.youtube.com/embed/_Qm6D1-6iNw?si=wS0aFcnkhLQee_6Y",
  },
  {
    title: "Azure Databricks",
    url: "https://www.youtube.com/embed/ml11yYFpQkY?si=8Bo1zVM1dj2N0zip",
  },
  {
    title: "Which is called as Course of the Year",
    url: "https://www.youtube.com/embed/jFJ2q-3F0Bs?si=dw2TRUWgK-D6xsaV",
  },
];

const Banner = () => {
  const scrollToTraining = useScrollToTraining();

  const handleTrainingClick = () => scrollToTraining();
  return (
    <Box
      sx={{
        background: `linear-gradient(135deg, rgba(15, 23, 42, 0.9), rgba(30, 41, 59, 0.9)), url(${BannerImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        py: { xs: 6, md: 8 },
        px: { xs: 3, md: 5 },
        color: "white",
        textAlign: "center",
      }}
    >
      <Grid container spacing={4} alignItems="center">
        {/* Left Side - Text & Tech Tags */}
        <Grid item xs={12} md={6} sx={{ textAlign: "left" }}>
          <Typography variant="h4" fontWeight="bold" sx={{ mb: 2 }}>
            Learn with{" "}
            <span style={{ color: "#ffd700", textShadow: "0px 0px 10px rgba(255, 215, 0, 0.7)" }}>
              Cloud UpSkill
            </span>
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, color: "#b0bec5", lineHeight: 1.6 }}>
            Take your career to the next level with industry-ready programs. An
            entire learning ecosystem at your fingertips to make learning fun.
            Choose from a range of tech programs and make your next big career switch.
          </Typography>

          {/* Tech Tags */}
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mb: 3 }}>
            {techTags.map((tag, index) => (
              <Chip
                key={index}
                label={tag}
                variant="outlined"
                sx={{
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  color: "white",
                  borderRadius: "8px",
                  borderColor: "rgba(255, 255, 255, 0.2)",
                  fontWeight: "bold",
                  transition: "all 0.3s ease-in-out",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                    transform: "scale(1.05)",
                  },
                }}
              />
            ))}
          </Box>

          {/* Buttons */}
          <Box sx={{ display: "flex", gap: 2 }}>
            <Button
              variant="contained"
              sx={{
                background: "linear-gradient(135deg, #ff4081, #e73370)",
                fontWeight: "bold",
                textTransform: "none",
                padding: "12px 24px",
                borderRadius: "8px",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  background: "#e73370",
                  transform: "scale(1.05)",
                  boxShadow: "0px 0px 12px rgba(255, 64, 129, 0.5)",
                },
              }}
              onClick={handleTrainingClick}
            >
              Explore Trainings
            </Button>
            <Button
              variant="contained"
              sx={{
                background: "linear-gradient(135deg, #00cc99, #009977)",
                fontWeight: "bold",
                textTransform: "none",
                padding: "12px 24px",
                borderRadius: "8px",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  background: "#009977",
                  transform: "scale(1.05)",
                  boxShadow: "0px 0px 12px rgba(0, 204, 153, 0.5)",
                },
              }}
            >
              Upcoming Batch
            </Button>
          </Box>
        </Grid>

        {/* Right Side - Scrolling YouTube Videos */}
        <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
          <Typography
            fontWeight="bold"
            sx={{
              mb: 2,
              backgroundColor: "#28a745",
              p: 1,
              borderRadius: "5px",
              display: "inline-block",
              boxShadow: "0px 0px 12px rgba(40, 167, 69, 0.5)",
              fontSize: '17px'
            }}
          >
            VIDEO RECORDING OF ALL SESSIONS WILL BE PROVIDED*
          </Typography>

          <Swiper
            modules={[Autoplay]}
            spaceBetween={20}
            slidesPerView={1}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            style={{
              maxWidth: "520px",
              borderRadius: "10px",
              boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.6)",
            }}
          >
            {videos.map((video, index) => (
              <SwiperSlide key={index}>
                <Box
                  sx={{
                    backgroundColor: "black",
                    borderRadius: "10px",
                    overflow: "hidden",
                    transition: "transform 0.3s ease-in-out",
                    "&:hover": { transform: "scale(1.02)" },
                  }}
                >
                  <iframe
                    width="100%"
                    height="300"
                    src={video.url}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{ borderRadius: "10px" }}
                  ></iframe>
                </Box>
              </SwiperSlide>
            ))}
          </Swiper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Banner;
